import '|/app.styl';
import './jquery.wake.js'

(function ($) {

    // This is for everyone
    window.$      = $;
    window.jQuery = jQuery;

    $(document).ready(function () {

        // Add some helper classes when the mobile menu is open
        $('.mobile-menu-toggle').on('click', function (event) {

            // Declare and initialize
            let toggleClassName = 'mobile-menu-open';
            let menu            = $('header .mobile-toggle-nav');
            let isOpen          = menu.hasClass('visible');

            // Things to do when the menu is not open yet
            if (isOpen) {

                // Add the class to the parent, for simplicity
                $(this).parent().addClass(toggleClassName);

                // Toggle the body class as well, just in case
                $('body').addClass(toggleClassName);

                // Hamburger to X
                $(this).find('.fa')
                    .removeClass('fa-navicon')
                    .addClass('fa-close');

            } else {

                // Add the class to the parent, for simplicity
                $(this).parent().removeClass(toggleClassName);

                // Toggle the body class as well, just in case
                $('body').removeClass(toggleClassName);

                // X to hamburger
                $(this).find('.fa')
                    .removeClass('fa-close')
                    .addClass('fa-navicon');

            }

        });

    });

    $(document).wake(function() {
        wpex.widthResizeUpdateConfig()
    })

})(jQuery);
